import { SnLonLat, SnLonLatLike } from '@lib/geo/helpers';

import { MapBaseOverlay } from '../base-overlay';
import { IBaseMarkerEvents } from './base-marker-events';
import { IBaseMarkerOptions } from './base-marker-options';

const DEFAULT_OPTIONS: IBaseMarkerOptions = {
  title: '',
};

export abstract class BaseMarker<
  TEvents extends IBaseMarkerEvents = IBaseMarkerEvents,
> extends MapBaseOverlay<TEvents> {
  protected lonLat: SnLonLat;
  protected title: string;

  protected constructor(options?: IBaseMarkerOptions) {
    super(options);

    options = { ...DEFAULT_OPTIONS, ...options };

    this.title = options.title;
    this.lonLat = options.lonLat ? SnLonLat.convert(options.lonLat) : undefined;
  }

  public getLonLat(): SnLonLat {
    return this.lonLat;
  }

  public setLonLat(lonLatLike: SnLonLatLike): this {
    this.lonLat = SnLonLat.convert(lonLatLike);
    this.fire('lonLatChange', this.lonLat);

    return this;
  }

  public getTitle(): string {
    return this.title;
  }

  public setTitle(title: string): this {
    if (this.title !== title) {
      this.title = title;

      this.fire('titleChange', title);
    }

    return this;
  }
}
